import { OMReference } from "@apptivity-lab/firmament-node-sdk"

import CatCategory from "../CatCategory"
import { ConcreteCategorizable } from ".."

declare module ".." {
    interface ConcreteCategorizable {
        categoriesForType(categoryType: string): CatCategory[]
        meetingTypeCategory(): CatCategory | undefined
        intensityCategory(): CatCategory | undefined
        accessibilityCategories(): CatCategory[]
    }
}

ConcreteCategorizable.prototype.categoriesForType = function(categoryType: string) {
    const typedCategories = (this.categories || []).reduce((categories: CatCategory[], current: OMReference<CatCategory>) => {
        const category = current.actualObject
        if (category && category.categoryType === categoryType) {
            categories.push(category)
        }
        return categories
    }, [])

    return typedCategories
}

ConcreteCategorizable.prototype.meetingTypeCategory = function() {
    const categories = this.categoriesForType("MEETING_TYPE")
    return categories.length > 0 ? categories[0] : undefined
}

ConcreteCategorizable.prototype.intensityCategory = function() {
    const categories = this.categoriesForType("INTENSITY")
    return categories.length > 0 ? categories[0] : undefined
}

ConcreteCategorizable.prototype.accessibilityCategories = function() {
    const categories = this.categoriesForType("ACCESSIBILITY")
    return categories
}
